export default __webpack_public_path__ + "images/79b9a94a06bd04105c555b0e067ae11b-previous.svg";